// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"onfido-sdk-ui-Complete-wrapper","submessage":"onfido-sdk-ui-Complete-submessage","icon":"onfido-sdk-ui-Complete-icon"};


//////////////////
// WEBPACK FOOTER
// ./components/Complete/style.css
// module id = 372
// module chunks = 1